import type { TFunction } from 'i18next';
import { Users } from '@tonnie/assets';
import { Badge, Card, CardContent, CardHeader, CardTitle } from '@tonnie/ui';
import { TaskCard } from './TaskCard';
import type { KitTask } from './types';

export function MemberSection({
  memberName,
  tasks,
  onRemoveTask,
  canRemove,
  getDependencyWarning,
  t,
}: {
  memberName: string;
  tasks: KitTask[];
  onRemoveTask: (code: string) => void;
  canRemove: (task: KitTask) => boolean;
  getDependencyWarning: (code: string) => string | null;
  t: TFunction;
}) {
  return (
    <Card>
      <CardHeader className="py-2 px-4">
        <CardTitle className="text-sm flex items-center gap-2">
          <Users className="w-4 h-4 text-muted-foreground" />
          {memberName}
          <Badge variant="secondary" className="text-xs">
            {tasks.length}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 pb-3 space-y-1.5">
        {tasks.map((task) => (
          <TaskCard
            key={task.task_code}
            task={task}
            onRemove={() => onRemoveTask(task.task_code)}
            canRemove={canRemove(task)}
            dependencyWarning={getDependencyWarning(task.task_code)}
            t={t}
          />
        ))}
      </CardContent>
    </Card>
  );
}
